// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"b41c1611","703":"fd5223cb","787":"c1f8b902"}[chunkId] + ".chunk.js";
};